module.exports = __webpack_public_path__ + "c159946bd9f8f377a46645d5156789a8.svg";